import { render, staticRenderFns } from "./ppt.vue?vue&type=template&id=5b5c77a6&scoped=true&"
import script from "./ppt.vue?vue&type=script&lang=js&"
export * from "./ppt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5c77a6",
  null
  
)

export default component.exports